
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import * as a from '../' 

type Props = {
}

export const AncientCard: React.FC<Props> = ({ children }) => {
    //const [isOpen, setIsOpen] = useState<boolean>(false)

    //const openGroup = () => {
    //    setIsOpen(!isOpen)
    //}
    //useEffect(() => { if (isOpen) onOpen(); }, [isOpen])

    return (
        <>
            <div className='row gy-5 gx-xl-12'>
                <div className='col-xxl-12'>

                    <div className={`card`}>
                        {children}
                    </div>
                </div>
            </div>
        </>
    )
}